import { toast } from 'sonner';
import i18next from 'i18next';

import { getIntegrationErrorMessage } from '@/lib/integration-error-message.js';

/**
 * Thin integration for platform seed-policy admin (page holds local state).
 */
export class SeedPolicyIntegration {
    constructor(sdkService) {
        this.service = sdkService;
    }

    async fetch() {
        try {
            const response = await this.service.get();
            return { success: true, data: response.data };
        } catch (error) {
            const message = getIntegrationErrorMessage(error)
                || i18next.t('seedPolicy:messages.loadFailed', {
                    defaultValue: 'Could not load seed policy',
                });
            toast.error(message);
            return { success: false, error: message };
        }
    }

    async update(payload) {
        try {
            const response = await this.service.update(payload);
            toast.success(
                i18next.t('seedPolicy:messages.updateSuccess', {
                    defaultValue: 'Seed policy saved',
                }),
            );
            return { success: true, data: response.data };
        } catch (error) {
            const message = getIntegrationErrorMessage(error)
                || i18next.t('seedPolicy:messages.updateFailed', {
                    defaultValue: 'Could not save seed policy',
                });
            toast.error(message);
            return { success: false, error: message };
        }
    }

    async listTombstones() {
        try {
            const response = await this.service.listTombstones();
            return { success: true, data: response.data || [] };
        } catch (error) {
            const message = getIntegrationErrorMessage(error)
                || i18next.t('seedPolicy:messages.loadFailed', {
                    defaultValue: 'Could not load seed policy',
                });
            toast.error(message);
            return { success: false, error: message, data: [] };
        }
    }

    async createTombstone(payload) {
        try {
            const response = await this.service.createTombstone(payload);
            toast.success(
                i18next.t('seedPolicy:messages.createTombstoneSuccess', {
                    defaultValue: 'Tombstone created',
                }),
            );
            return { success: true, data: response.data };
        } catch (error) {
            const message = getIntegrationErrorMessage(error)
                || i18next.t('seedPolicy:messages.createTombstoneFailed', {
                    defaultValue: 'Could not create tombstone',
                });
            toast.error(message);
            return { success: false, error: message };
        }
    }

    async deleteTombstone(id) {
        try {
            const response = await this.service.deleteTombstone(id);
            toast.success(
                i18next.t('seedPolicy:messages.deleteTombstoneSuccess', {
                    defaultValue: 'Tombstone deleted',
                }),
            );
            return { success: true, data: response.data };
        } catch (error) {
            const message = getIntegrationErrorMessage(error)
                || i18next.t('seedPolicy:messages.deleteTombstoneFailed', {
                    defaultValue: 'Could not delete tombstone',
                });
            toast.error(message);
            return { success: false, error: message };
        }
    }
}
